import { StatutJure } from './statut-jure.model';
import { College } from './college.model';
import { Jure } from './jure.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';

export class JureJury {
    static jsonMap = {
        jure: { key: 'idJure', converter: new (DataIdConverterFactory.build(Jure, 'jures'))() },
        statut: { key: 'idStatut', converter: new (DataIdConverterFactory.build(StatutJure, 'statutsJure'))() },
        college: { key: 'idCollege', converter: new (DataIdConverterFactory.build(College, 'colleges'))() }
    };

    jure: Jure;
    statut: StatutJure;
    college: College;
}
